'use client';

import { useLocale } from 'next-intl';
import { useMemo } from 'react';

import { useOccupationChildrenQuery, useOccupationRootsQuery } from '@/modules/shared/application';
import { toListCollectionFromLeafs } from '@/utils/helpers/collection';

export const useOccupationCollections = (categoryId?: string, subCategoryId?: string) => {
	const locale = useLocale();

	const { data: categories = [] } = useOccupationRootsQuery();
	const { data: subCategories = [] } = useOccupationChildrenQuery(categoryId);
	const { data: specializations = [] } = useOccupationChildrenQuery(subCategoryId);

	const categoryCollection = useMemo(
		() => toListCollectionFromLeafs(categories, locale),
		[ categories, locale ],
	);
	const subCategoryCollection = useMemo(
		() => toListCollectionFromLeafs(subCategories, locale),
		[ subCategories, locale ],
	);
	const specializationCollection = useMemo(
		() => toListCollectionFromLeafs(specializations, locale),
		[ specializations, locale ],
	);

	return {
		categoryCollection,
		specializationCollection,
		subCategoryCollection,
	};
};
